// Import Packages
import React from "react";
import { useTranslation } from "react-i18next";

// Import Material UI
import ArchiveSharpIcon from "@material-ui/icons/ArchiveSharp";
import HourglassEmptySharpIcon from '@material-ui/icons/HourglassEmptySharp';
import ArchiveOutlinedIcon from "@material-ui/icons/ArchiveOutlined";
import CenterFocusStrongIcon from '@material-ui/icons/CenterFocusStrong';
//import ZoomInIcon from "@material-ui/icons/ZoomIn";
//import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import Zoom from '@material-ui/core/Zoom';
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

// Import Pages
import Info from "./Info";

// Import Icons
import UndoIcon from '../../../../../assets/icons/shortCutIcons/undo-icon.svg';
import RedoIcon from '../../../../../assets/icons/shortCutIcons/redo-icon.svg';
import ZoomInIcon from '../../../../../assets/icons/shortCutIcons/zoom-in-icon.svg';
import ZoomOutIcon from '../../../../../assets/icons/shortCutIcons/zoom-out-icon.svg';

import PasteIcon from '../../../../../assets/icons/shortCutIcons/paste-icon.svg'
import PasteInsideIcon from '../../../../../assets/icons/shortCutIcons/paste-inside-icon.svg'
import CutIcon from '../../../../../assets/icons/shortCutIcons/cut-icon.svg'
import CopyIcon from '../../../../../assets/icons/shortCutIcons/copy-icon.svg'
import DeleteIcon from '../../../../../assets/icons/shortCutIcons/delete-icon.svg'
import ImportIcon from '../../../../../assets/icons/shortCutIcons/import-icon.svg'
import ExportIcon from '../../../../../assets/icons/shortCutIcons/export-icon.svg'
import CenterIcon from '../../../../../assets/icons/shortCutIcons/center-icon.svg'
import MSTeamsIcon from '../../../../../assets/icons/shortCutIcons/msteams-icon.svg'
import WhatsappIcon from '../../../../../assets/icons/shortCutIcons/whatsapp-icon.svg'

const ShortCutSection = (props) => {
    const { t } = useTranslation();

    return (
        <div className="tabs">
            <ul>
                {/* <>
                    <Info value={t("CONTENT.FLOW.COPY")} placement="right">
                        <li onClick={() => props.onCopy()}>
                            <img src={CopyIcon} alt="" />
                        </li>
                    </Info>
                    <Info value={t("CONTENT.FLOW.CUT")} placement="right">
                        <li onClick={() => props.onCut()}>
                            <img src={CutIcon} alt="" />
                        </li>
                    </Info>
                    <Info value={t("CONTENT.FLOW.PASTE")} placement="right">
                        <li onClick={() => props.onPaste(false)}>
                            <img src={PasteIcon} alt="" />
                        </li>
                    </Info>
                    <Info value={t("CONTENT.FLOW.PASTE-INSIDE")} placement="right">
                        <li onClick={() => props.onPaste(true)}>
                            <img src={PasteInsideIcon} alt="" />
                        </li>
                    </Info>
                    <Info value={t("CONTENT.FLOW.DELETE")} placement="right">
                        <li onClick={() => props.onDelete()}>
                            <img src={DeleteIcon} alt="" />
                        </li>
                    </Info>
                    {!props.isDesktopRecorder &&
                        <>
                            <Info value={t("CONTENT.FLOW.IMPORT")} placement="right">
                                <li onClick={props.handleImport}>
                                    <img src={ImportIcon} alt="" />
                                </li>
                            </Info>
                            <Info value={t("CONTENT.FLOW.EXPORT")} placement="right">
                                <li onClick={props.handleExport}>
                                    <img src={ExportIcon} alt="" />
                                </li>
                            </Info>

                            {props.isDebugging && (
                                <Zoom in={props.isDebugging}>
                                    <Info value={t("CONTENT.FLOW.SLOW-MOTION")} placement="right">
                                        <li className="debug-icon" onClick={props.handleSlowMotion} style={{ backgroundColor: "rgb(215, 94, 94)" }}>
                                            <HourglassEmptySharpIcon
                                                style={{ transform: "rotate(180deg)", fill: "white" }} />
                                        </li>
                                    </Info>
                                </Zoom>
                            )}

                            {props.isMSTeamsExist && (
                                <Zoom in={props.isMSTeamsExist}>
                                    <Info value={t("CONTENT.FLOW.RESET-SESSION")} placement="right">
                                        <li className="reset-icon" onClick={props.handleResetMSTeamsSession} style={{ backgroundColor: "white" }}>
                                            <img src={MSTeamsIcon} alt="" />
                                        </li>
                                    </Info>
                                </Zoom>
                            )}

                            {props.isWhatsappExist && (
                                <Zoom in={props.isWhatsappExist}>
                                    <Info value={t("CONTENT.FLOW.RESET-SESSION")} placement="right">
                                        <li className="reset-icon" onClick={props.resetWPSession} style={{ backgroundColor: "white" }}>
                                            <img src={WhatsappIcon} alt="" />
                                        </li>
                                    </Info>
                                </Zoom>
                            )}
                        </>
                    }
                </> */}
                <div
                    className={`tabs-bottom-icons ${props.isDebugging
                        ? props.isDebuggingExpand
                            ? "tabs-bottom-icons-debug-expand"
                            : "tabs-bottom-icons-debug"
                        : ""
                        }`}
                >
                    <Info value={t("CONTENT.FLOW.REDO")} placement="top">
                        <li onClick={() => props.onForward()}>
                            <img src={RedoIcon} alt="" />
                        </li>
                    </Info>
                    <Info value={t("CONTENT.FLOW.UNDO")} placement="top">
                        <li onClick={() => props.onBack()}>
                            <img src={UndoIcon} alt="" />
                        </li>
                    </Info>

                    <Info value={t("CONTENT.FLOW.ZOOM-IN")} placement="top">
                        <li onClick={(e) => props.changeScale(e, "zoom-in")}>
                            <img src={ZoomInIcon} alt="" />
                        </li>
                    </Info>

                    <Info value={t("CONTENT.FLOW.ZOOM-OUT")} placement="top">
                        <li id="zoom-out" onClick={(e) => props.changeScale(e, "zoom-out")}>
                            <img src={ZoomOutIcon} alt="" />
                        </li>
                    </Info>

                    <Info value={t("CONTENT.FLOW.CENTER")} placement="top">
                        <li onClick={() => props.handleScreen()}>
                            <img src={CenterIcon} alt="" />
                        </li>
                    </Info>
                </div>
            </ul>
            <div>
                {/* <div>

                    {debugRunning ? (
                        <div style={{ position: "relative" }}>
                            <Info value={t("CONTENT.FLOW.STOP")} placement="bottom">
                                <StopIcon className={classes.stop} onClick={handleCancel} />
                            </Info>
                            <CircularProgress size={24} />
                        </div>
                    ) : (
                        <button
                            disabled={!automDetail.status}
                            style={{ cursor: "pointer", opacity: `${!automDetail.status ? "0.5" : "1"}` }}
                            aria-controls="email-trigger-menu"
                            aria-haspopup="true"
                            onClick={() => runFlow()}
                            onMouseEnter={(e) => handleEmailTriggerMenu(e)}
                        >
                            <Info value={t("CONTENT.FLOW.RUN")} placement="bottom">
                                <img src={PlayIcon} alt="" />
                            </Info>
                        </button>
                    )}

                    <StyledMenu
                        style={{ marginTop: 2 }}
                        id="email-trigger-menu"
                        onMouseLeave={() => setAnchorEl(null)}
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        MenuListProps={{ onMouseLeave: handleClose }}
                    >
                        <MenuItem
                            style={{ fontSize: 11, fontWeight: "600" }}
                            onClick={runFlow}
                        >
                            {t("CONTENT.FLOW.RUN-FLOW")}
                        </MenuItem>
                        {trigger &&
                            (isRunning ? (
                                <MenuItem
                                    style={{ fontSize: 11, fontWeight: "600" }}
                                    onClick={handleStop}
                                >
                                    {t("CONTENT.FLOW.STOP-" + triggerType)}
                                </MenuItem>
                            ) : (
                                <>
                                    {triggerType === "APP-TRIGGER" ? (
                                        <>
                                            <MenuItem
                                                style={{ fontSize: 11, fontWeight: "600" }}
                                                onClick={() => handleStart(true)}
                                            >
                                                {t("CONTENT.FLOW.TEST-" + triggerType)}
                                            </MenuItem>
                                            <MenuItem
                                                style={{ fontSize: 11, fontWeight: "600" }}
                                                onClick={() => handleStart(false)}
                                            >
                                                {t("CONTENT.FLOW.START-" + triggerType)}
                                            </MenuItem>
                                        </>
                                    ) : (
                                        <MenuItem
                                            style={{ fontSize: 11, fontWeight: "600" }}
                                            onClick={() => handleStart(false)}
                                        >
                                            {t("CONTENT.FLOW.START-" + triggerType)}
                                        </MenuItem>
                                    )}

                                </>
                            ))}
                    </StyledMenu>
                </div> */}
            </div>

        </div>

    );
};

export default ShortCutSection;
